import {useValidate} from "../../hooks";
import {useContext} from "react";
import {ResponseStatus, StatusContextApi} from "../../context/status";
import {getKeyByValue} from "../../data-parsing/parseUtils";
import {User} from "../../data-parsing/users/User";
import {CreationForm, CreationFormTemplate} from "../../components/form/CreationForm";
import {ConfirmDoctorFormTemplate} from "../../data-parsing/doctors/FormTemplate";
import {Doctor} from "../../data-parsing/doctors/Doctor";
import {useParams} from "react-router-dom";

export function ConfirmUser() {
    const {id} = useParams();
    const {validate, confirmDoctor} = useValidate(id);
    const {addMessage} = useContext(StatusContextApi);


    function validateFields(formData) {
        if (formData.get(getKeyByValue(User, User.password)) !== formData.get(getKeyByValue(User, User.passwordVerification))) {
            addMessage(ResponseStatus.ERROR, 5000, "Los valores de contraseña introducidos no coinciden");
            return false;
        }
        return true;
    }

    return <div id="wrapper">
        <div className="container">
            <div className="row">
                <div className="col-xs-12">
                    <div className="card-box card-tabs m-t-20">
                        <div className="row">
                            <h4 className="header-title m-r-10 m-t-0 pull-right">CONFIRMACIÓN DE CUENTA</h4>
                        </div>
                        <h4 className="m-t-10">Valida los datos de tu cuenta e introduce una contraseña de más 6 caracteres</h4>
                        <div className="row">
                            <CreationForm createFunction={confirmDoctor} validateForm={validateFields}>

                                <CreationFormTemplate formTemplate={ConfirmDoctorFormTemplate} dataTemplate={Doctor}
                                                      defaultData={validate}/>
                                {/*Additional field to send the id together with the rest of the data*/}
                                <input name="url" type={"hidden"} value={id}/>
                                <div className="col-sm-12">
                                    <button
                                        className="btn btn-rounded btn-purple m-b-20 ml-10"><i
                                        className="far fa-save"></i> Actualizar
                                        Datos
                                    </button>

                                </div>
                            </CreationForm>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
}